
const CardStat = ({ title, value, icon, color }) => {
  return (
    <div className="bg-white shadow rounded-xl py-8 px-4 flex items-center justify-between ">
      <div className="grid gap-3 w-3/5 pe-2">
        <h3 className={`text-sm font-medium font-inter ${color} h-1/2`}>{title.toUpperCase()}</h3>
        <p className="text-2xl font-bold text-gray-800 font-mandali">{value}</p>
      </div>
      <div className="bg-blue-50 p-4 rounded-lg w-2/5 inline-flex justify-center">{icon}</div>
    </div>
  );
};

export default CardStat;